// utils/swalHelper.js
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export const showSwal = ({
    icon = 'success',
    title = '',
    text = '',
    confirmButtonText = 'OK',
    cancelButtonText = 'Cancel',
    showCancelButton = false,
    onConfirm = null,
    onCancel = null,
}) => {
    return MySwal.fire({
        icon,
        title,
        text,
        confirmButtonText,
        cancelButtonText,
        showCancelButton,
        customClass: {
            confirmButton: 'btn btn-success btn-w-md',
            cancelButton: 'btn btn-secondary-light btn-w-md',
        },
        buttonsStyling: false,
    }).then((result) => {

        if (icon == "success" && !showCancelButton) {
            if (onConfirm) onConfirm();
            return
        }

        if (result.isConfirmed) {
            if (onConfirm) onConfirm();
        }

        if (result.isDismissed) {
            if (onCancel) onCancel();
        }

    });
};
